import { type PropsWithChildren } from 'react';
import type { Layout } from '@mentimeter/http-clients';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ImageProgressive } from '@mentimeter/ragnar-ui/image-progressive';

interface SideBySideImageProps {
  imageUrl: string;
  imageAltText?: string | undefined;
  layoutType: Layout['type'] | undefined;
  imageWidth?: '0%' | '10%' | '25%' | '33%' | '35%' | '50%' | '66%' | undefined;
}

export const SideBySideImage = ({
  children,
  imageUrl,
  imageAltText,
  layoutType,
  imageWidth,
}: PropsWithChildren<SideBySideImageProps>) => {
  const flexDirection =
    layoutType === 'side-by-side-right' ? 'row-reverse' : 'row';

  return (
    <Box flexDirection={flexDirection} width="100%" height="100%">
      <Box
        height="100%"
        width={imageWidth}
        justifyContent="center"
        alignItems="center"
        data-testid="side-by-side-image"
        px="space4"
      >
        <ImageProgressive src={imageUrl} alt={imageAltText || ''} />
      </Box>
      <Box flex="1" height="100%" justifyContent="center" alignItems="center">
        {children}
      </Box>
    </Box>
  );
};
